import { Component } from '@angular/core';

@Component({
  selector: 'Diot-component',
  styles: [],
  templateUrl: 'diot.component.html'
})

export class Diot {}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/diot/diot.component.ts